module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA40lEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBevBp+P///9+/f4EkUMN/GABKxxXPisqbtmjh2sjcqXFFsxAagOqgSE4OzgZK//z19/+N3X8Ozvn/6hqQjdAAcTTCSStW9PbvBUo/vv/g6+5pP64d/Lyu6dGtm0g2TJ/uV7gDrqG6az/E02+fPv13YMbvrR3/L21+c/82QgOQhRXNWH/i5PUHx48fP33r8fQNJwlrYNAvY6g5w1B9GkgC2fg0IJBhGWP0IgYDkGoUDQQRuRoGJQAAX9zY2ADyRYEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AI.png
// module id = 1071
// module chunks = 0